import { useLatest } from 'ahooks';
import { useEffect } from 'react';
import { Editor } from '@meitu/saas-editor-core';

/**
 * 编辑器舞台状态改变
 * @returns
 */
export const useEditorStateChange = (editor: Editor, onChange: () => void) => {
    const fnRef = useLatest(onChange);

    useEffect(() => {
        return editor.onState(() => {
            fnRef.current();
        });
    }, []);
};
